// src/components/layout/Footer.js
import React from 'react';
import { Box, Typography, Link as MuiLink, Container } from '@mui/material';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.grey[100]
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
        >
          {'© '}
          DivScore {new Date().getFullYear()}
          {' | '}
          <MuiLink href="/privacy" color="inherit">
            Privacy Policy
          </MuiLink>
          {' | '}
          <MuiLink href="/terms" color="inherit">
            Terms of Service
          </MuiLink>
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;